import axios_nomura from './axios-nomura.services';
import axios_mock from './axios-mock.services';

export const fetchHotfundByTopBottom = async (data) => {
  return await axios_nomura.get(`api/v1/hotcategories/topbottom`, {
    params: {
      dateType: data.dateType ?? null,
      startedAt: data.startedAt ?? null,
      endedAt: data.endedAt ?? null,
      fundTypes: data.fundTypes ?? [],
      sortBy: data.sortBy,
      sortType: data.sortType,
    }
  });
};

export const fetchHotfundAll = async (data) => {
  return await axios_nomura.get(`api/v1/hotcategories/all`, {
    params: {
      dateType: data.dateType ?? null,
      startedAt: data.startedAt ?? null,
      endedAt: data.endedAt ?? null,
      fundTypes: data.fundTypes ?? [],
      sortBy: data.sortBy,
      sortType: data.sortType,
    }
  });
};

export const fetchGraphCompareCategories = async (data) => {
  return await axios_nomura.get(`/api/v1/hotcategories/graph`,
    {
      params: {
        startDate: data.startDate ?? '',
        endDate: data.endDate ?? '',
        categoryCodes: data.categoryCodes,
        fundTypes: data.fundTypes,
      }
    }
  );
};
